<!--
 * @Description: 导入活动人员错误弹窗
 * @Date: 2023-05-05 14:33:01
-->
<template>
  <div style="padding: 20px">
    <div class="error-alert">
      <p>
        信息校验结果:
        {{ sizeSuccess }}
      </p>
      <p>导入结果: 整批导入失败</p>
      <p>错误内容:</p>
    </div>
    <BaseTable
      style="min-height: 300px"
      ref="baseTableRef"
      :data="(tablePageData as any[])"
      :columns="columns"
    ></BaseTable>
    <BasePagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :page-sizes="[15, 60, 100]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableData.length"
      @size-change="handleSizeChange"
      @current-change="handleSizeChange"
    ></BasePagination>
    <BaseButton @click="excelErrorDownload" style="margin: 20px 0">
      下载错误Excel
    </BaseButton>
    <span style="justify-content: center; display: flex; margin: 10px">
      <BaseButton @click="onCancel">取消</BaseButton>
      <BaseButton type="primary" @click="onSubmit">重新提交</BaseButton>
    </span>
  </div>
</template>
<script lang="tsx" setup>
import { ref, computed } from 'vue';
import {
  BaseButton,
  BaseTable,
  BaseTableProps,
  BaseInput,
  useTableColumn,
  XrkMessage,
  createDialog,
  XrkMessageBox
} from 'xrk-components';
import { downloadErrExcel, cancelImport } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    done: Function;
    importCount: number;
    failCount: number;
    dataList: any[];
    form: {
      excelCode: string;
    };
  }>(),
  {
    done: null,
    form: () => ({
      excelCode: ''
    })
  }
);

const currentPage = ref(1);
const pageSize = ref(15);

const emits = defineEmits(['againSubmit']);

const tableData = ref(props.dataList);
const isCellShow = ref(null);
const sizeSuccess = computed(() => {
  return `导入${props.importCount}条，失败${props.failCount}条`;
});

const excelErrorDownload = () => {
  downloadErrExcel({ excelCode: props.form.excelCode });
};

const tablePageData = ref(
  tableData.value.slice(
    (currentPage.value - 1) * pageSize.value,
    currentPage.value * pageSize.value
  )
);

const handleSizeChange = ({ currentPage, pageSize }) => {
  tablePageData.value = tableData.value.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
};
const columns: BaseTableProps['columns'] = [
  useTableColumn({
    label: '表格位置',
    prop: 'rowNumStr'
  }),
  useTableColumn({
    label: '姓名',
    prop: 'activityPeopleName',
    render: ({ row }) => {
      return isCellShow.value === 'activityPeopleName' + row.rowNum ? (
        <BaseInput
          placeholder="请输入姓名"
          ref="editInput"
          onInput={e => {
            row.activityPeopleName = e;
          }}
          v-model={row.activityPeopleName}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'activityPeopleName' + row.rowNum;
          }}
          type="text"
        >
          {row.activityPeopleName || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '手机号',
    prop: 'phone',
    render: ({ row }) => {
      return isCellShow.value === 'phone' + row.rowNum ? (
        <BaseInput
          type="tel"
          ref="editInput"
          placeholder="请输入手机号"
          onInput={e => {
            row.phone = e;
          }}
          v-model={row.phone}
          onBlur={() => {
            isCellShow.value = '';
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'phone' + row.rowNum;
          }}
          type="text"
        >
          {row.phone || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '结算金额',
    prop: 'price',
    render: ({ row }) => {
      const inputRule = num => {
        let errMsg = '';
        if (+num > 90000) {
          errMsg = '输入数字不可大于90000';
          row.price = 90000;
        }
        if (errMsg) {
          createDialog({
            width: '300px',
            title: '提示',
            showClose: true,
            showFooter: false,
            content: errMsg
          });
          return;
        }
        row.price = num;
      };
      return isCellShow.value === 'price' + row.rowNum ? (
        <BaseInput
          ref="editInput"
          type="tel"
          maxlength={6}
          placeholder="请输入结算金额"
          onInput={e => {
            inputRule(e);
          }}
          v-model={row.price}
          onBlur={() => {
            isCellShow.value = '';
          }}
          onFocus={() => {
            inputRule(+row.price);
          }}
        ></BaseInput>
      ) : (
        <BaseButton
          onClick={() => {
            isCellShow.value = 'price' + row.rowNum;
          }}
          type="text"
        >
          {row.price || '-'}
        </BaseButton>
      );
    }
  }),
  useTableColumn({
    label: '错误提示',
    width: '300px',
    render: ({ row }) => {
      return row.errorMsgList.map((item, index) => {
        return <p>{`${index + 1}.${item.errorMsg}`}</p>;
      });
    }
  }),
  useTableColumn({
    label: '操作',
    render: ({ index }) => {
      return (
        <BaseButton
          onClick={() => {
            XrkMessageBox.confirm('此操作将删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              tableData.value.splice(index, 1);
              tablePageData.value = tableData.value.slice(
                (currentPage.value - 1) * pageSize.value,
                currentPage.value * pageSize.value
              );
              XrkMessage({
                type: 'success',
                message: '删除成功!'
              });
            });
          }}
          type="text"
        >
          删除
        </BaseButton>
      );
    }
  })
];

async function onSubmit() {
  await XrkMessageBox.confirm('是否确认重新提交？');
  emits('againSubmit', {
    dataList: tableData.value
  });
  props.done();
}
const onCancel = async () => {
  await cancelImport({ excelCode: props.form.excelCode });
  props.done();
};
</script>
<style lang="scss" scoped>
.error-alert {
  p {
    margin-bottom: 10px;
    color: red;
  }
}
</style>
